<template lang="pug">
  el-row
    p.label-divider {{label}} &nbsp
      span(slot="label")
        el-tooltip(
          v-if="tooltip"
          effect='light',
          placement='bottom'
        )
          span(slot="content")
            p(v-html="tooltip")
          i.el-icon-info
    .divider
    slot(name="body")
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
.label-divider {
  padding-top: 30px;
  font-weight: bold;
}

.divider {
  border: 1px solid $--divider-color;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/Divider.vue